// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  shipId: __t.u64().primaryKey().name("ship_id"),
  owner: __t.identity(),
  chassisKey: __t.string().name("chassis_key"),
  engine: __t.u32(),
  weapons: __t.u32(),
  judgedEngine: __t.u32().name("judged_engine"),
  judgedWeapons: __t.u32().name("judged_weapons"),
  fitRev: __t.string().name("fit_rev"),
  bucket: __t.f64(),
  bucketAtMs: __t.f64().name("bucket_at_ms"),
  reports: __t.u32(),
  lastCause: __t.string().name("last_cause"),
  lastProv: __t.string().name("last_prov"),
  rulesVersion: __t.u32().name("rules_version"),
  updatedAt: __t.timestamp().name("updated_at"),
});
